import { TFunction } from 'i18next'
import AuthService from '../Authentication/AuthService'
import { createCredentialsType } from '../Authentication/AuthTypes'
import LoginRestService from '../rest/LoginRestService'
import { errorHandlerType } from '../utils/ErrorMessage'

class LoginService {
  tryAutoLogin(setAutoLoginFinished: React.Dispatch<React.SetStateAction<boolean>>, refreshAuthentication: () => void, refreshUserDetails: () => void) {
    LoginRestService.autoLogin()
      .then((userDetails) => LoginService.loadUserDetails(userDetails, refreshUserDetails))
      .catch(() => console.log('auto login failed. Redirecting to login page.'))
      .finally(() => {
        setAutoLoginFinished(true)
        refreshAuthentication()
      })
  }

  /** generate Token
   * @param credentials - user's auth username and password
   *
   */
  async login(
    username: string,
    password: string,
    setErrorMessage: (errorMessage: errorHandlerType | string | null) => void,
    setShowError: (show: boolean) => void,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    refreshAuthentication: () => void,
    refreshUserDetails: () => void
  ) {
    setLoading(true)
    LoginRestService.login(createCredentialsType(username, password))
      .then((userDetails) => {
        LoginService.loadUserDetails(userDetails, refreshUserDetails)
      })
      .catch((error) => {
        setLoading(false)
        setErrorMessage(error.message)
        setShowError(true)
      })
      .finally(() => refreshAuthentication())
  }

  async logOut(refreshAuthentication: () => void, refreshUserDetails: () => void) {
    await AuthService.removeAuthToken()
    refreshAuthentication()
    await AuthService.removeUserDetails()
    refreshUserDetails()
  }

  async updatePassword(data: any, t: TFunction, refreshUserDetails: () => void, setLoading?: React.Dispatch<React.SetStateAction<boolean>>) {
    if (setLoading) {
      setLoading(true)
    }
    if (data.newPassword !== data.confirmPassword) {
      const error = {
        message: t('passwordUpdate.mismatch'),
        statuscode: 400,
        level: 'ERROR',
      }
      if (setLoading) {
        setLoading(false)
      }
      return Promise.reject(error)
    }
    try {
      const userDetail = await LoginRestService.updatePassword(data)
      AuthService.storeUserDetails(userDetail)
      refreshUserDetails()
      if (setLoading) {
        setLoading(false)
      }
      return t('passwordUpdate.success')
    } catch (error) {
      if (setLoading) {
        setLoading(false)
      }
      return Promise.reject(error)
    }
  }

  static async loadUserDetails(userDetails: any, refreshUserDetails: () => void) {
    try {
      await AuthService.storeUserDetails(userDetails)
      refreshUserDetails()
    } catch (error) {
      console.log(error)
    }
  }
}

export default new LoginService()
